;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import type { StocklistSourceNameSchema } from '@qogita/canary-client/sellers'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@qogita/ui/v2/select'
import { getStockTypeLabel } from 'src/features/price-lists/constants'

export function PriceListSelector({
  stocklistSources,
  value,
  onValueChange,
}: {
  stocklistSources: StocklistSourceNameSchema[]
  value?: string
  onValueChange: (qid: string) => void
}) {
  return (
    <div className="flex basis-full items-center gap-3 lg:basis-auto">
      <p className="typography-subheader-lg-semibold text-high-emphasis shrink-0">
        Price lists:
      </p>

      <Select value={value} onValueChange={onValueChange}>
        <SelectTrigger className="w-full lg:w-70">
          <SelectValue key={value} />
        </SelectTrigger>
        <SelectContent>
          {stocklistSources.map((source) => {
            const stockTypeLabel = getStockTypeLabel(source.stockType)

            return (
              <SelectItem key={source.qid} value={source.qid}>
                <span className="inline-flex">
                  <span className="max-w-40 truncate">{source.name}</span>
                  <span className="text-low-emphasis">· {stockTypeLabel}</span>
                </span>
              </SelectItem>
            )
          })}
        </SelectContent>
      </Select>
    </div>
  )
}
